"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var ProjectStore_1 = __importDefault(require("Project/Stores/ProjectStore"));
var ProjectStatusSetter = (function () {
    function ProjectStatusSetter(notifyUser, $http, apiBaseUrl, $log, telemetry, projectLiveCounter) {
        var _this = this;
        this.notifyUser = notifyUser;
        this.$http = $http;
        this.apiBaseUrl = apiBaseUrl;
        this.$log = $log;
        this.telemetry = telemetry;
        this.projectLiveCounter = projectLiveCounter;
        this.setStatus = function (projects, status) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!lodash_1.default.isArray(projects)) {
                            projects = [projects];
                        }
                        if (!this.checkValidChange(projects, status)) return [3, 2];
                        return [4, this.performRequest(projects, status).catch(function (err) {
                                _this.$log.error(err);
                                _this.notifyUser.error("Could not change the status of the page(s)");
                                return Promise.reject(err);
                            })];
                    case 1:
                        _a.sent();
                        return [2, projects.forEach(function (project) {
                                project.status = status;
                            })];
                    case 2: return [2, Promise.reject(new Error("Not a valid status change"))];
                }
            });
        }); };
        this.makeDraft = function (project) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.toggleDraftLive(project, Types_1.ProjectStatus.Draft)];
                    case 1:
                        _a.sent();
                        this.projectLiveCounter.remove();
                        return [2];
                }
            });
        }); };
        this.makeLive = function (project) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.toggleDraftLive(project, Types_1.ProjectStatus.Live)];
                    case 1:
                        _a.sent();
                        this.projectLiveCounter.add();
                        return [2];
                }
            });
        }); };
        this.disableProjects = function (projects) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!lodash_1.default.isArray(projects)) {
                            projects = [projects];
                        }
                        return [4, this.setStatus(projects, Types_1.ProjectStatus.Disabled)];
                    case 1:
                        _a.sent();
                        this.telemetry.track("Project Security Link Disabled");
                        return [2];
                }
            });
        }); };
        this.enableProjects = function (projects) {
            if (!lodash_1.default.isArray(projects)) {
                projects = [projects];
            }
            return _this.setStatus(projects, Types_1.ProjectStatus.Draft);
        };
        this.checkValidChange = function (projects, status) {
            var e_1, _a;
            var projectsArray;
            if (!lodash_1.default.isArray(projects)) {
                projectsArray = [projects];
            }
            else {
                projectsArray = projects;
            }
            try {
                for (var projectsArray_1 = __values(projectsArray), projectsArray_1_1 = projectsArray_1.next(); !projectsArray_1_1.done; projectsArray_1_1 = projectsArray_1.next()) {
                    var project = projectsArray_1_1.value;
                    if (!_this.checkValidChangeForSingleProject(project, status)) {
                        return false;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (projectsArray_1_1 && !projectsArray_1_1.done && (_a = projectsArray_1.return)) _a.call(projectsArray_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return true;
        };
        this.toggleDraftLive = function (project, newStatus) {
            if (project == null) {
                return Promise.reject(new Error("No project given to make draft"));
            }
            if (lodash_1.default.isArray(project)) {
                return Promise.reject(new Error("Too many projects given, we only allow 1"));
            }
            if (project.status === newStatus) {
                return Promise.reject(new Error("Project is already in given mode: \"".concat(newStatus, "\"")));
            }
            if (!["", "live"].includes(newStatus)) {
                return Promise.reject(new Error("Given status is not supported by this function"));
            }
            if (_this.checkValidChangeForSingleProject(project, newStatus)) {
                var oldStatus_1 = project.status;
                if (project instanceof ProjectStore_1.default) {
                    project.setStatus({ status: newStatus });
                }
                else {
                    project.status = newStatus;
                    return _this.performSingleProjectRequest(project, newStatus).catch(function (err) {
                        project.status = oldStatus_1;
                        return Promise.reject(err);
                    });
                }
            }
            else {
                return Promise.reject(new Error("Cannot change that project's status"));
            }
        };
        this.checkValidChangeForSingleProject = function (project, newStatus) {
            if (!_this.isValidProject(project) || !_this.isValidStatus(newStatus)) {
                return false;
            }
            if (_this.isProjectAccepted(project)) {
                _this.notifyUser.error("An accepted page cannot change status");
                return false;
            }
            return true;
        };
        this.performRequest = function (projects, status) {
            var projectIds = lodash_1.default.map(projects, function (project) { return project._id; });
            return _this.$http.post("".concat(_this.apiBaseUrl, "/projects/bulk"), {
                projects: projectIds,
                data: {
                    status: status,
                },
            });
        };
        this.performSingleProjectRequest = function (project, status) {
            return _this.$http.post("".concat(_this.apiBaseUrl, "/projects/").concat(project._id, "/status"), { status: status });
        };
        this.areValidProjects = function (projects) {
            return lodash_1.default.reduce(projects, function (acc, project) { return _this.isValidProject(project) && acc; }, true);
        };
        this.isValidProject = function (project) {
            return project != null && project._id;
        };
        this.isValidStatus = function (status) {
            switch (status) {
                case "accepted":
                case "disabled":
                case "":
                case "live":
                    return true;
                default:
                    return false;
            }
        };
        this.isProjectAccepted = function (project) {
            return project.status === Types_1.ProjectStatus.Accepted;
        };
    }
    return ProjectStatusSetter;
}());
exports.default = ProjectStatusSetter;
